import { render } from "./CustomersTab.vue?vue&type=template&id=0131fd00"
import script from "./CustomersTab.vue?vue&type=script&lang=js"
export * from "./CustomersTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/AccountReceivable/CustomersTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0131fd00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0131fd00', __exports__)) {
    api.reload('0131fd00', __exports__)
  }
  
  module.hot.accept("./CustomersTab.vue?vue&type=template&id=0131fd00", () => {
    api.rerender('0131fd00', render)
  })

}


export default __exports__